import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import formatProductPrice from '../../core/formatProductPrice';

window.formatProductPrice = formatProductPrice;

require('../../core/dashboard-init');
require('../arm-file-field');

// Ensure jQuery is available
if (typeof jQuery === 'undefined') {
    console.error('jQuery is not loaded. navToggle will not work.');
} else {
    // Use both document.ready and window.load for maximum compatibility
    $(document).ready(function () {
        navToggle();
        initProfileMenuToggle();
        initHeaderUserDropdown();

        // headerStickyHandle();

        initProductsSlider();

        bikeFavoriteToggle();

        showQuickViewModal();

        reportAnIssueHandler();

        renewProductHandler();

        initCategoriesOverlay();
    });

    // Also try on window load as fallback
    $(window).on('load', function () {
        // Re-initialize navToggle if it didn't work on ready
        const burger = $('#navToggle');
        const navbar = $('.header-wrapper');
        if (burger.length && navbar.length && !burger.data('navToggle-initialized')) {
            navToggle();
        }
    });
}

const headerStickyHandle = () => {
    const isMobile = $(window).width() < 991;
    const header = $('#header');
    let lastScrollTop = 0;

    if (isMobile) {
        $(window).on('scroll', { passive: true }, function () {
            let scrollTop = $(window).scrollTop();

            if (scrollTop > lastScrollTop) {
                header.addClass('hide');
            } else {
                header.removeClass('hide');
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });
    }
}

// Global fallback function for onclick handler
window.toggleNavSidebar = function (e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    // Try multiple selectors for better compatibility
    const burger = document.getElementById('navToggle') || document.querySelector('.burger');
    const navbar = document.querySelector('.header-wrapper');

    if (!burger || !navbar) {
        console.warn('toggleNavSidebar: Elements not found', {
            burger: !!burger,
            navbar: !!navbar
        });
        return;
    }

    burger.classList.toggle('active');
    navbar.classList.toggle('show');

    if (navbar.classList.contains('show')) {
        document.body.classList.add('overflow-hidden');
    } else {
        document.body.classList.remove('overflow-hidden');
    }
};

const navToggle = () => {
    // Retry mechanism for production environments
    const initNavToggle = () => {
        const burger = $('#navToggle');
        const navbar = $('.header-wrapper');

        if (!burger.length || !navbar.length) {
            console.warn('navToggle: Elements not found', {
                burger: burger.length,
                navbar: navbar.length
            });
            // Retry after a short delay if elements not found
            if (!burger.data('navToggle-retry-attempted')) {
                burger.data('navToggle-retry-attempted', true);
                setTimeout(initNavToggle, 200);
            }
            return;
        }

        // Mark as initialized to prevent duplicate initialization
        if (burger.data('navToggle-initialized')) {
            return;
        }
        burger.data('navToggle-initialized', true);

        // Remove any existing handlers to prevent duplicates
        burger.off('click.navToggle touchstart.navToggle');
        $(document).off('click.navToggle');

        // Add both click and touch handlers for mobile compatibility
        burger.on('click.navToggle touchstart.navToggle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const $burger = $(this);
            const $navbar = $('.header-wrapper');

            if (!$navbar.length) {
                console.warn('navToggle: Navbar element not found on click');
                return;
            }

            const isActive = $burger.hasClass('active');

            $burger.toggleClass('active');
            $navbar.toggleClass('show');

            if ($navbar.hasClass('show')) {
                $('body').addClass('overflow-hidden');
            } else {
                $('body').removeClass('overflow-hidden');
            }
        });

        // Close sidebar when clicking outside - use event delegation
        $(document).on('click.navToggle', function (e) {
            const $navbar = $('.header-wrapper');
            if ($navbar.hasClass('show') && !$(e.target).closest('.header-wrapper, #navToggle').length) {
                burger.removeClass('active');
                $navbar.removeClass('show');
                $('body').removeClass('overflow-hidden');
            }
        });
    };

    // Start initialization
    initNavToggle();
}

window.initProfileMenuToggle = function initProfileMenuToggle() {
    const button = $('.profile-menu-btn');
    const sidebar = $('.profile-left');

    if (!button.length || !sidebar.length || button.data('profile-menu-initialized')) {
        return;
    }

    button.data('profile-menu-initialized', true);

    function positionProfileSidebar() {
        if (window.innerWidth >= 992) {
            sidebar.removeAttr('style');
            return;
        }

        const rect = button[0].getBoundingClientRect();
        const edgeGap = 16;
        const menuGap = 24;
        const sidebarWidth = Math.min(296, window.innerWidth - (edgeGap * 2));

        sidebar.css({
            top: rect.bottom + menuGap,
            right: edgeGap,
            left: 'auto',
            width: sidebarWidth,
        });
    }

    button.on('click.profileMenu', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $button = $(this);
        const isOpen = sidebar.hasClass('show');

        if (!isOpen) {
            positionProfileSidebar();
        }

        $button.toggleClass('active', !isOpen);
        sidebar.toggleClass('show', !isOpen);
    });

    sidebar.on('click.profileMenu', function (e) {
        e.stopPropagation();
    });

    $(document).on('click.profileMenu', function (e) {
        if ($(e.target).closest('.profile-menu-btn, .profile-left').length) {
            return;
        }

        button.removeClass('active');
        sidebar.removeClass('show');
    });

    $(window).on('resize.profileMenu scroll.profileMenu', function () {
        if (!sidebar.hasClass('show')) {
            return;
        }

        positionProfileSidebar();
    });
};

function mobileHeaderDropdownEnabled() {
    return window.innerWidth < 992;
}

function configureHeaderUserDropdown($dropdown) {
    const $toggle = $dropdown.find('.dropdown-toggle');

    if (!$toggle.length) {
        return;
    }

    if ($toggle.data('bs.dropdown')) {
        $toggle.dropdown('dispose');
    }

    if (mobileHeaderDropdownEnabled()) {
        $toggle.dropdown({
            display: 'static',
            flip: false,
            boundary: 'window',
            offset: 0,
        });
    } else {
        $toggle.dropdown({
            display: 'dynamic',
            offset: '0,18',
        });
    }
}

function positionHeaderUserDropdownMenu($dropdown) {
    if (!mobileHeaderDropdownEnabled()) {
        return;
    }

    const toggle = $dropdown.find('.dropdown-toggle')[0];
    let $menu = $dropdown.data('mobile-dropdown-menu');

    if (!$menu || !$menu.length) {
        $menu = $dropdown.find('.dropdown-menu').first();
        $menu.addClass('header-user-dropdown-menu--portal');
        $('body').append($menu);
        $dropdown.data('mobile-dropdown-menu', $menu);
    }

    if (!toggle || !$menu.length) {
        return;
    }

    $menu.addClass('show');

    const headerSearch = document.querySelector('.header > .container > .header-search.d-lg-none');
    const headerInner = document.querySelector('.header-inner');
    const anchorEl = headerSearch || headerInner || toggle;
    const anchorRect = anchorEl.getBoundingClientRect();
    const edgeGap = 12;
    const menuGap = 10;
    const menuWidth = 240;
    const top = anchorRect.bottom + menuGap;
    const menuEl = $menu[0];

    menuEl.style.setProperty('position', 'fixed', 'important');
    menuEl.style.setProperty('top', `${top}px`, 'important');
    menuEl.style.setProperty('right', `${edgeGap}px`, 'important');
    menuEl.style.setProperty('left', 'auto', 'important');
    menuEl.style.setProperty('bottom', 'auto', 'important');
    menuEl.style.setProperty('transform', 'none', 'important');
    menuEl.style.setProperty('margin', '0', 'important');
    menuEl.style.setProperty('width', `${menuWidth}px`, 'important');
    menuEl.style.setProperty('z-index', '1100', 'important');
}

function resetHeaderUserDropdownMenu($dropdown) {
    const $menu = $dropdown.data('mobile-dropdown-menu');

    if (!$menu || !$menu.length) {
        return;
    }

    $menu.removeClass('show header-user-dropdown-menu--portal').removeAttr('style');
    $dropdown.append($menu);
    $dropdown.removeData('mobile-dropdown-menu');
}

window.initHeaderUserDropdown = function initHeaderUserDropdown() {
    const $dropdown = $('.header .user-dropdown');

    if (!$dropdown.length || $dropdown.data('header-user-dropdown-initialized')) {
        return;
    }

    $dropdown.data('header-user-dropdown-initialized', true);

    configureHeaderUserDropdown($dropdown);

    $dropdown.on('show.bs.dropdown', function () {
        positionHeaderUserDropdownMenu($(this));
    });

    $dropdown.on('shown.bs.dropdown', function () {
        const $item = $(this);
        positionHeaderUserDropdownMenu($item);
        window.requestAnimationFrame(function () {
            positionHeaderUserDropdownMenu($item);
        });
    });

    $dropdown.on('hide.bs.dropdown', function () {
        resetHeaderUserDropdownMenu($(this));
    });

    $(window).on('resize.headerUserDropdown', function () {
        $dropdown.each(function () {
            configureHeaderUserDropdown($(this));
        });

        $dropdown.each(function () {
            const $item = $(this);

            if (!$item.hasClass('show')) {
                return;
            }

            positionHeaderUserDropdownMenu($item);
        });
    });

    $(window).on('scroll.headerUserDropdown', function () {
        $dropdown.each(function () {
            const $item = $(this);

            if (!$item.hasClass('show')) {
                return;
            }

            positionHeaderUserDropdownMenu($item);
        });
    });
};

const initProductsSlider = () => {
    const productsSliderOptions = {
        spaceBetween: 12,
        slidesPerView: 2,
        modules: [Navigation, Autoplay],
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
        },
        navigation: {
            prevEl: '.products-slider-prev',
            nextEl: '.products-slider-next',
        },
        breakpoints: {
            576: {
                spaceBetween: 16,
                slidesPerView: 2,
            },
            991: {
                spaceBetween: 20,
                slidesPerView: 3,
            },
            1200: {
                spaceBetween: 24,
                slidesPerView: 4,
            },
        },
    };

    document.querySelectorAll('.products-slider').forEach((slider) => {
        if (slider.dataset.swiperReady === '1') {
            return;
        }

        const start = () => {
            if (slider.dataset.swiperReady === '1') {
                return;
            }

            slider.dataset.swiperReady = '1';

            new Swiper(slider, {
                ...productsSliderOptions,
                navigation: {
                    prevEl: slider.parentElement?.querySelector('.products-slider-prev') ?? '.products-slider-prev',
                    nextEl: slider.parentElement?.querySelector('.products-slider-next') ?? '.products-slider-next',
                },
            });
        };

        if (!('IntersectionObserver' in window)) {
            start();
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                observer.disconnect();
                start();
            }
        }, { rootMargin: '240px 0px' });

        observer.observe(slider);
    });
}

const updateFavorite = async (id = null, isFavorite) => {
    await axios.post(route('wishlist.update', id), { 'is_favorite': isFavorite });
}

const favoriteAnimation = (buttonEl) => {
    const destinationEl = $('#wishlistDestination i');
    const icon = buttonEl.find('svg');
    const clone = icon.clone();
    const $body = document.body;

    clone.offset({
        top: $(icon).offset().top,
        left: $(icon).offset().left,
    }).css({
        position: 'absolute',
        pointerEvents: 'none',
        opacity: '0.5',
        stroke: '#DB4444',
        fill: '#DB4444',
        color: '#DB4444',
        width: $(destinationEl).width(),
        height: $(destinationEl).height(),
        zIndex: 1000,
    }).appendTo($($body)).animate({
        top: $(destinationEl).offset().top,
        left: $(destinationEl).offset().left,
    }, 'ease', () => {
        clone.fadeOut(500, function () {
            $(this).detach();
        });
    });
};

const bikeFavoriteToggle = () => {
    $(document).on('click', '.product-item-favorite', function (e) {
        e.preventDefault();

        const countWrapper = $('#wishlistDestination > span');
        let count = +countWrapper.html();

        const id = $(this).data('product-id');

        if (loggedIn) {
            if (!$(this).hasClass('active')) {
                favoriteAnimation($(this));

                if (!countWrapper.length) {
                    $('#wishlistDestination').append($('<span>1</span>'));
                } else {
                    count++;
                }
            } else {
                count--;
            }

            countWrapper.html(count);

            if (count <= 0) {
                countWrapper.remove();
            }

            $(this).toggleClass('active');

            updateFavorite(id, $(this).hasClass('active'));
        } else {
            window.location.href = route('login');
        }

        if (window.location.href.includes('wishlist')) {
            setTimeout(() => {
                window.location.reload();
            }, 400)
        }
    });
}

const quickViewModalSlider = () => {
    new Swiper('.quick-view-slider', {
        modules: [Navigation, Pagination],
        spaceBetween: 5,
        slidesPerView: 1,
        navigation: {
            nextEl: '.products-quick-slider-next',
            prevEl: '.products-quick-slider-prev',
        },
        pagination: {
            clickable: true,
            el: '.swiper-pagination',
        },
    });
}

const showQuickViewModal = () => {
    const modal = $('#quickViewModal');
    const loader = $('.quick-view-loader-wrapper');

    $(document).on('click', '.product-item-quick-view', function (e) {
        e.preventDefault();

        const productId = $(this).data('product-id');

        loader.removeClass('d-none');

        modal.find('.modal-content').html('');
        modal.modal('show');

        axios.get(route('products.quick', productId)).then(html => {
            modal.find('.modal-content').html(html.data);
            quickViewModalSlider();
        }).catch(er => console.log(er)).finally(resp => {
            loader.addClass('d-none');
        });

    });
}

const reportAnIssueHandler = () => {
    $('#reportAnIssueBtn').on('click', function () {
        $('.global-loader').removeClass('d-none');
        const form = $('#reportAnIssueForm');
        form.find('.alert-success').addClass('d-none')

        const formData = new FormData(form[0]);

        $('.invalid-inp-message').remove();

        $.ajax({
            method: 'POST',
            processData: false,
            contentType: false,
            url: route('reportAnIssue'),
            data: formData,
            success: () => {
                $('.global-loader').addClass('d-none');
                form.find('.alert-success').removeClass('d-none');
                form.find(`input, textarea`).val('');
            },
            error: err => {
                $('.global-loader').addClass('d-none');
                for (const errorsKey in err.responseJSON.errors) {
                    form
                        .find(`input[name=${errorsKey}], textarea[name=${errorsKey}]`)
                        .parent()
                        .append(`<small class="text-danger invalid-inp-message">${err.responseJSON.errors[errorsKey][0]}</small>`)
                }
            }
        })
    });
}

const renewProductHandler = () => {
    $(document).on('click', '.productId-renew-btn, .profile-renew-btn', function (e) {
        e.preventDefault();

        const button = $(this);
        const productId = button.data('product-id');
        const expirationCard = button.closest('.productId-expiration-card, .profile-product-expiration');
        const productItem = button.closest('.profile-product-item, .productId-expiration-card');

        if (!productId) {
            alert('Product ID not found');
            return;
        }

        // Disable button during request
        button.prop('disabled', true);
        const originalText = button.html();
        button.html('<span style="margin-right: 8px;">⏳</span>Renewing...');

        // Get current locale for API URL
        const locale = window.location.pathname.split('/')[1] || 'en';
        const apiUrl = `/${locale}/api/v1/profile/products/${productId}/renew`;

        axios.post(apiUrl, {}, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            withCredentials: true
        }).then(response => {
            if (response.data.success) {
                // Show success message
                const successMessage = '<div class="alert alert-success" style="margin-top: 15px; padding: 12px; border-radius: 6px; background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb;">✓ ' + (window.$trans ? window.$trans('main.Product renewed successfully') : 'Product renewed successfully') + '</div>';

                if (expirationCard.length) {
                    expirationCard.append(successMessage);
                } else if (productItem.length) {
                    productItem.prepend(successMessage);
                }

                // Reload page after 2 seconds to show updated expiration date
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                throw new Error(response.data.message || 'Failed to renew product');
            }
        }).catch(error => {
            let errorMessage = 'Error renewing product';

            if (error.response) {
                if (error.response.status === 401) {
                    errorMessage = 'Please log in to renew your product';
                    // Redirect to login
                    if (typeof route !== 'undefined') {
                        window.location.href = route('login');
                    } else {
                        window.location.href = '/login';
                    }
                    return;
                } else if (error.response.status === 403) {
                    errorMessage = 'You are not authorized to renew this product';
                } else if (error.response.status === 404) {
                    errorMessage = 'Product not found';
                } else if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            }

            alert(errorMessage);

            // Re-enable button
            button.prop('disabled', false);
            button.html(originalText);
        });
    });
}


const initCategoriesOverlay = () => {
    const categoriesBtn = $('#headerCategoriesBtn, #headerCategoriesBtnMobile, #headerCategoriesBtnMobileHome');
    const overlay = $('#categoriesOverlay');
    const closeBtn = $('#categoriesOverlayClose');

    if (!categoriesBtn.length || !overlay.length) {
        console.warn('Categories overlay elements not found');
        return;
    }

    if (overlay.data('categoriesOverlayInit')) {
        return;
    }

    overlay.data('categoriesOverlayInit', true);

    function openCategoriesOverlay() {
        if (!overlay.length) return;
        overlay.addClass('show');
        $('body').addClass('overflow-hidden');

        // Show first main type by default if none is active
        if (!$('.category-main-type-btn.active').length) {
            const firstMainType = $('.category-main-type-item').first();
            if (firstMainType.length) {
                const mainTypeId = firstMainType.data('main-type-id');
                $('.category-main-type-btn').removeClass('active');
                firstMainType.find('.category-main-type-btn').addClass('active');
                $('.categories-content-panel').hide();
                $(`#categories-panel-${mainTypeId}`).show();
            }
        }
    }

    function closeCategoriesOverlay() {
        if (!overlay.length) return;
        overlay.removeClass('show');
        $('body').removeClass('overflow-hidden');
    }

    function toggleCategoriesOverlay() {
        if (overlay.hasClass('show')) {
            closeCategoriesOverlay();
        } else {
            openCategoriesOverlay();
        }
    }

    // Click only — no hover open (avoids accidental opens when moving the mouse)
    categoriesBtn.off('click.categoriesOverlay').on('click.categoriesOverlay', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        toggleCategoriesOverlay();
    });

    closeBtn.off('click.categoriesOverlay').on('click.categoriesOverlay', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeCategoriesOverlay();
    });

    overlay.off('click.categoriesOverlay').on('click.categoriesOverlay', function (e) {
        if ($(e.target).is(overlay)) {
            closeCategoriesOverlay();
        }
    });

    $(document).off('keydown.categoriesOverlay').on('keydown.categoriesOverlay', function (e) {
        if (e.key === 'Escape' && overlay.hasClass('show')) {
            closeCategoriesOverlay();
        }
    });

    // Handle main type selection
    $(document).on('click', '.category-main-type-btn', function (e) {
        e.preventDefault();
        const mainTypeId = $(this).data('main-type-id');

        // Update active state
        $('.category-main-type-btn').removeClass('active');
        $(this).addClass('active');

        // Show corresponding panel
        $('.categories-content-panel').hide();
        $(`#categories-panel-${mainTypeId}`).show();
    });

    // Handle category dropdown toggle
    $(document).on('click', '.category-dropdown-toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $button = $(this);
        const categoryId = $button.data('category-id');
        const $content = $(`#category-dropdown-${categoryId}`);
        const $icon = $button.find('.category-dropdown-icon');
        const $item = $button.closest('.category-item-dropdown');

        if (!$content.length) {
            console.error('Category dropdown content not found for ID:', categoryId);
            return;
        }

        // Toggle content with animation
        if ($content.is(':visible')) {
            $content.slideUp(300);
            $item.removeClass('is-open');
            $icon.removeClass('rotated');
        } else {
            $content.slideDown(300);
            $item.addClass('is-open');
            $icon.addClass('rotated');
        }
    });

}
